export enum CategoriaFamiliaEnum {
  CATALISADORES_PECAS = 'CATALISADORES_PECAS',
  CATALISADORES_PO = 'CATALISADORES_PO',
  PLACAS = 'PLACAS',
}

export enum FamiliaScopesEnum {
  ComUsuarioCreatedUpdated = 'ComUsuarioCreatedUpdated',
}
